// Cualquier fallo de transporte puede llegar después de que ARCA recibió el
// envío. Solo una confirmación explícita del backend permite afirmar lo contrario.
const errores = (error) => [error?.graphQLErrors, error?.networkError?.result?.errors, error?.errors]
  .flatMap((items) => (Array.isArray(items) ? items : []));
const publico = (value) => typeof value === "string" && !/(?:app_|admin_)[\w.-]+|Bearer\s|eyJ[\w-]+\.|password|authorization|secret|\bat\s+\S+\s*\(|https?:\/\/|SELECT\s.+FROM/i.test(value)
  ? value.replace(/[\u0000-\u001f\u007f]/g, " ").replace(/<[^>]*>/g, "").trim().slice(0, 1500) : "";
export const diagnosticoErrorFacturacion = (error) => {
  const fiscal = errores(error).find(item => item?.extensions?.facturacion)?.extensions?.facturacion;
  const d = fiscal?.diagnostico;
  if (!d || typeof d !== "object") return null;
  return {
    titulo: publico(d.titulo), causa: publico(d.causa), dato: publico(d.dato), accion: publico(d.accion),
    contexto: publico(d.contexto), origen: ["ARCA", "API"].includes(d.origen) ? d.origen : null,
    estadoEmision: publico(d.estadoEmision), referencia: publico(d.referencia), codigo: publico(d.codigo),
    sugerencias: Array.isArray(d.sugerencias) ? d.sugerencias.slice(0, 8).map(publico).filter(Boolean) : [],
    advertencias: Array.isArray(d.advertencias) ? d.advertencias.slice(0, 8).map(publico).filter(Boolean) : [],
  };
};
export const mensajeErrorFiscal = (error, fallback = "No se pudo completar la facturación. Revisá el historial para confirmar el estado del envío.") => {
  const d = diagnosticoErrorFacturacion(error);
  const mensajes = errores(error).map(item => publico(typeof item === "string" ? item : item?.message)).filter(Boolean);
  const causa = d?.causa || [...new Set(mensajes)].join(" | ") || publico(fallback)
    || "No se pudo completar la facturación. Revisá el historial para confirmar el estado del envío.";
  if (d) {
    return [causa, d.contexto, d.dato ? `Dato a revisar: ${d.dato}.` : null, ...d.sugerencias, ...d.advertencias, d.estadoEmision, d.accion, d.referencia ? `Referencia: ${d.referencia}` : null].filter(Boolean).join(" ");
  }
  return causa;
};

export const validacionPreviaConfirmada = (error) => errores(error).some(item => {
  const f = item?.extensions?.facturacion;
  return f?.etapa === "VALIDACION_PREVIA" && f.facturaRegistrada === false;
});
